import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { mayLeavePage } from "./leaveGuard";

export const useGuardedNavigate = (): ((to: string) => void) => {
  const navigate = useNavigate();
  return useCallback(
    (to: string) => {
      if (mayLeavePage()) navigate(to);
    },
    [navigate],
  );
};
